import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

class Wrapper extends Component {
  ALLOWED_MODIFIERS = [
    'center', 'column', 'end', 'fullHeight',
    'inline', 'middle', 'spaceBetween', 'spaceAround',
    'fullWidth', 'start', 'overflowHidden', 'viewportHeight'
  ]

  componentClassNames = () => {
    return bemClasses('wrapper', this.ALLOWED_MODIFIERS, this.props)
  }

  render = () => {
    return (
      <span onClick={this.props.onClick} className={this.componentClassNames()}>
        { this.props.children }
      </span>
    )
  }
}

export default Wrapper
